export const Environment = {
    BACKEND_HOST: "https://api.medicallaw.co.kr",
    MANAGEMENT_SITE_NAME: "태신 의료 관리자"
  };